/* eslint-disable */
import { addWidgetsFromContext } from "@insite/client-framework/Components/ContentItemStore";

const widgets = require.context("../../blueprints/MasterBluePrint/src/Widgets", true, /.tsx$/);
addWidgetsFromContext(widgets);
